import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ResizeSensor } from 'css-element-queries';

@Component({
	selector: 'aspect-ratio-container',
	templateUrl: './aspect-ratio-container.component.html',
	styleUrls: ['./aspect-ratio-container.component.scss']
})
export class AspectRatioContainerComponent implements OnInit, OnChanges, OnDestroy {
	@Input() public ratio!: string;

	private aspectRatio!: number;
	private resizeSensor!: ResizeSensor;

	constructor (private elementRef: ElementRef) {}

	public ngOnInit (): void {
		const nativeElement = this.elementRef.nativeElement;
		this.updateRatio(this.ratio);

		this.resizeSensor = new ResizeSensor(nativeElement.parentElement, () => {
			this.resize(this.aspectRatio);
		});

		this.resize(this.aspectRatio);
	}

	public ngOnChanges (changes: SimpleChanges): void {
		if (changes.ratio) {
			this.updateRatio(changes.ratio.currentValue);
		}
	}

	private updateRatio (ratio: string): void {
		if (!ratio) {
			throw new Error('Property binding `ratio` is required');
		}

		const match = ratio.match(/(\d+):(\d+)/);
		if (!match) {
			throw new Error('Property binding `ratio` is invalid');
		}

		this.aspectRatio = parseFloat(match[1]) / parseFloat(match[2]);
		this.resize(this.aspectRatio);
	}

	public ngOnDestroy (): void {
		if (this.resizeSensor) {
			this.resizeSensor.detach();
		}
	}

	private resize (aspectRatio: number): void {
		const nativeElement = this.elementRef.nativeElement;
		const parentElement = nativeElement.parentElement;
		const boundingRect = parentElement.getBoundingClientRect();

		let containerWidth = boundingRect.width;
		let containerHeight = boundingRect.height;

		// Minus parent padding
		const containerStyle = window.getComputedStyle(parentElement);
		containerWidth -= parseFloat(containerStyle.paddingLeft) + parseFloat(containerStyle.paddingRight);
		containerHeight -= parseFloat(containerStyle.paddingTop) + parseFloat(containerStyle.paddingBottom);

		// Minus element margin
		const elementStyle = window.getComputedStyle(nativeElement);
		containerWidth -= parseFloat(elementStyle.marginLeft) + parseFloat(elementStyle.marginRight);
		containerHeight -= parseFloat(elementStyle.marginTop) + parseFloat(elementStyle.marginBottom);

		const containerRatio = containerWidth / containerHeight;
		if (aspectRatio > containerRatio) {
			nativeElement.style.width = `${Math.ceil(containerWidth)}px`;
			nativeElement.style.height = `${Math.ceil(containerWidth / aspectRatio)}px`;
		} else {
			nativeElement.style.width = `${Math.ceil(containerHeight * aspectRatio)}px`;
			nativeElement.style.height = `${Math.ceil(containerHeight)}px`;
		}
	}
}
